/**
 * AA POS番号のバリデーションルール定義
 * 各AAコードに対応するバリデーションルールを管理
 */

/**
 * 先頭アルファベット+数字のバリデーションが必要なAAコード
 */
export const ALPHA_START_NUMBER_AA_CODES = [
  '00021',
  '00022',
  '00023',
  '00024',
  '00025',
  '00026',
  '00027',
  '00028',
  '00029',
  '00031',
  '00032',
  '00033',
  '00034',
  '00035',
  '00036',
  '00037',
  '00078',
  '00108',
  '00109',
  '00110',
  '00111',
  '00125',
  '00127',
  '00129',
  '00130',
  '00131',
  '00132',
  '00190',
  '00222',
  '00228',
  '00240',
  '00250',
]

/**
 * 数字のみのバリデーションが必要なAAコード
 */
export const NUMBER_ONLY_AA_CODES = [
  '00038',
  '00039',
  '00040',
  '00042',
  '00043',
  '00044',
  '00045',
  '00046',
  '00047',
  '00048',
  '00049',
  '00050',
  '00051',
  '00052',
  '00053',
  '00054',
  '00055',
  '00056',
  '00057',
  '00058',
  '00059',
  '00060',
  '00061',
  '00062',
  '00063',
  '00064',
  '00065',
  '00066',
  '00067',
  '00068',
  '00069',
  '00070',
  '00071',
  '00072',
  '00073',
  '00074',
  '00075',
  '00076',
  '00077',
  '00079',
  '00080',
  '00081',
  '00082',
  '00083',
  '00084',
  '00085',
  '00086',
  '00087',
  '00088',
  '00089',
  '00090',
  '00091',
  '00101',
  '00102',
  '00113',
  '00114',
  '00115',
  '00116',
  '00119',
  '00121',
  '00123',
  '00126',
  '00134',
  '00136',
  '00156',
  '00157',
  '00158',
  '00180',
  '00191',
  '00192',
  '00193',
  '00194',
  '00195',
  '00196',
  '00199',
  '00200',
  '00204',
  '00205',
  '00206',
  '00208',
  '00209',
  '00211',
  '00212',
  '00213',
  '00218',
  '00221',
  '00222',
  '00223',
  '00224',
  '00227',
  '00229',
  '00230',
  '00231',
  '00233',
  '00235',
  '00237',
  '00238',
  '00239',
  '00241',
  '00242',
  '00243',
  '00244',
  '00245',
  '00251',
  '00252',
  '00254',
  '00256',
  '00257',
]

/**
 * AAコードに応じたバリデーションルール名を取得
 * @param {String} aaCd - AAコード
 * @returns {String} バリデーションルール名
 */
export const getAaPosValidationRule = (aaCd) => {
  if (ALPHA_START_NUMBER_AA_CODES.includes(aaCd)) {
    return 'alphaStartNumber'
  }

  if (NUMBER_ONLY_AA_CODES.includes(aaCd)) {
    return 'number'
  }

  // デフォルトルール（必要に応じて変更）
  return ''
}



// WEBPACK FOOTER //
// ./src/constants/aaPosValidation.js